export const languages = [
    {
        id: 'en',
        shortLabel: 'EN',
        labelKey: 'languages.english',
    },
    {
        id: 'fr',
        shortLabel: 'FR',
        labelKey: 'languages.french',
    }
]

export const ROLE_OWNER = 1;
export const ROLE_AUTHOR = 2;
export const ROLE_READER = 4;
export const ROLE_PRESENTER = 8;

export const isOwnerOf = (slideshow) => {
    return (slideshow.myAccesses[0].roles & ROLE_OWNER) === ROLE_OWNER 
}

export const isAuthorOf = (slideshow) => {
    return (slideshow.myAccesses[0].roles & ROLE_AUTHOR) === ROLE_AUTHOR 
}

export const isReaderOf = (slideshow) => {
    return (slideshow.myAccesses[0].roles & ROLE_READER) === ROLE_READER 
}

export const isPresenterOf = (slideshow) => {
    return (slideshow.myAccesses[0].roles & ROLE_PRESENTER) === ROLE_PRESENTER 
}

export const template = [
    {
        content: ``  
    }, 
    
    {
        content: `# Part 1
## Part 1.1
Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. 
* Lorem ipsum dolor sit amet
* Lorem ipsum dolor sit amet
* Lorem ipsum dolor sit amet
* Lorem ipsum dolor sit amet`  
    }, 

    {
        content: `# Summary
1. Part 1
2. Part 2
3. Part 3
4. Part 4
5. Part 5`  
    },

    {
        content: `# Title
![](https://www.3ds.com/assets/invest/3dexcite/3dshome-26/images/WEST.png)
Neque porro quisquam est qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit`  
    },
    
]